/* unplugin-vue-components disabled */import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, createVNode as _createVNode } from "vue";
import _imports_0 from '@/assets/img/arrow.png';
import _imports_1 from '@/assets/img/arrow_2.png';
var _hoisted_1 = {
  class: "collapse-list"
};
var _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "collapse-item-right-icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "arrow_1"
}), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "arrow_2"
})], -1);
var _hoisted_3 = ["onClick"];
var _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "van-collapse-item-title-icon"
}, null, -1);
var _hoisted_5 = {
  class: "collapse-item-title-text"
};
var _hoisted_6 = {
  class: "van-collapse"
};
var _hoisted_7 = {
  class: "van-collapse-content"
};
var _hoisted_8 = {
  class: "content-item"
};
var _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "设备型号", -1);
var _hoisted_10 = {
  class: "content-item-value"
};
var _hoisted_11 = {
  class: "content-item"
};
var _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "所在位置", -1);
var _hoisted_13 = {
  class: "content-item-value"
};
var _hoisted_14 = {
  class: "content-item"
};
var _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "告警内容", -1);
var _hoisted_16 = {
  class: "content-item-value"
};
var _hoisted_17 = {
  class: "content-item"
};
var _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "告警时间", -1);
var _hoisted_19 = {
  class: "content-item-value"
};
var _hoisted_20 = {
  class: "content-item"
};
var _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "恢复时间", -1);
var _hoisted_22 = {
  class: "content-item-value"
};
var _hoisted_23 = {
  class: "content-item"
};
var _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "处理人", -1);
var _hoisted_25 = {
  class: "content-item-value"
};
var _hoisted_26 = {
  class: "van-collapse-footer"
};
import './collapseList.less';
// // eslint-disable-next-line no-undef
export default /*#__PURE__*/_defineComponent({
  __name: 'CollapseList',
  props: {
    listData: {
      default: function _default() {
        return [];
      }
    },
    detailUrl: {}
  },
  setup: function setup(__props) {
    var props = __props;
    var listData = props.listData;
    var router = useRouter();
    var activeNames = ref('');
    var goToDetail = function goToDetail(id) {
      router.push({
        path: '/deviceAlarm/detail',
        query: {
          id: id
        }
      });
    };
    return function (_ctx, _cache) {
      var _component_van_collapse_item = _resolveComponent("van-collapse-item");
      var _component_van_collapse = _resolveComponent("van-collapse");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_collapse, {
        modelValue: _unref(activeNames),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(activeNames) ? activeNames.value = $event : null;
        }),
        accordion: ""
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listData), function (item, index) {
            return _openBlock(), _createBlock(_component_van_collapse_item, {
              key: index,
              name: index
            }, {
              "right-icon": _withCtx(function () {
                return [_hoisted_2];
              }),
              title: _withCtx(function () {
                return [_createElementVNode("div", {
                  class: "van-collapse-item-title",
                  onClick: _withModifiers(function ($event) {
                    return goToDetail(item.id);
                  }, ["stop"])
                }, [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString(item.deviceName || '--'), 1)], 8, _hoisted_3)];
              }),
              default: _withCtx(function () {
                return [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, _toDisplayString(item.deviceModel || '--'), 1)]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, _toDisplayString(item.deviceAddr || '--'), 1)]), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, _toDisplayString(item.deviceWarnInfo || '--'), 1)]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", _hoisted_19, _toDisplayString(item.deviceWarnTime || '--'), 1)]), _createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", _hoisted_22, _toDisplayString(item.deviceResumeTime || '--'), 1)]), _createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("div", _hoisted_25, _toDisplayString(item.dealWithName || '--'), 1)])]), _createElementVNode("div", _hoisted_26, [_renderSlot(_ctx.$slots, "footer", {
                  item: item
                })])])];
              }),
              _: 2
            }, 1032, ["name"]);
          }), 128))];
        }),
        _: 3
      }, 8, ["modelValue"])]);
    };
  }
});